export const config = {
  api_url: process.env.VUE_APP_API_URL,
  token_key: "user-auth",
  stripe_url: process.env.VUE_REDIRECT_STRIPE
};
